<script setup lang="ts">
  import { Stepper } from '@travelata-libs/ui-kit';
  import { computed } from 'vue';

  interface AdultsStepperProps {
    value: number;
    min?: number;
    max?: number;
    testid: string;
  }

  const props = withDefaults(defineProps<AdultsStepperProps>(), {
    min: 1,
    max: 6,
  });

  interface AdultsStepperEmits {
    (e: 'update:value', v: number): void;
  }

  const emit = defineEmits<AdultsStepperEmits>();

  const model = computed({
    get: () => props.value,
    set: (value) => emit('update:value', value),
  });
</script>

<template>
  <div class="tourists-adults-stepper">
    <Stepper
      v-model="model"
      :data-testid="testid"
      :min="min"
      :max="max"
    />
  </div>
</template>

<style scoped lang="scss">
  .tourists-adults-stepper {
    align-items: center;
    display: flex;
    gap: var(--spacing-xs);
  }
</style>
